import { render, staticRenderFns } from "./IconStepperInactive.vue?vue&type=template&id=1052fac8"
import script from "./IconStepperInactive.vue?vue&type=script&lang=js"
export * from "./IconStepperInactive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports